import { useTranslation } from "react-i18next";
import { PlatformSettings } from "@/partner/features/platformSettings";
import { Meta } from "@/shared/components";

export const PlatformSettingsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("platformSettings.pageTitle")} pageType="Partner" />
      <PlatformSettings />
    </>
  );
};
